import React, { useEffect, useState } from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'
import { generateTmpAudio } from '@editor/store/thunks/audio.thunk'
import { unwrapResult } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@store/store'
import { useTheme } from '@config/themeContext'
import XmlEditor from '@editor/components/misc/xmlEditor'
import CustomAudioPlayer from '@editor/components/misc/customAudioPlayer'

const AudioPage = () => {
  const { theme } = useTheme()
  const dispatch: AppDispatch = useDispatch()
  const [audioUrl, setAudioUrl] = useState<string | undefined>(undefined)
  const [ssmlText, setSsmlText] = useState<string>('')
  const [audioLoading, setAudioLoading] = useState<boolean>(false)

  const getAudio = (e: any) => {
    e.preventDefault()
    setAudioLoading(true)
    setAudioUrl(undefined)
    toast.info(`Audio se generuje`)
    dispatch(generateTmpAudio(ssmlText))
      .then(unwrapResult)
      .then(onGetAudioSuccess)
      .catch(onGetAudioError)
      .finally(() => setAudioLoading(false))
  }

  const onGetAudioSuccess = (tmpAudio: any) => {
    if (tmpAudio && tmpAudio.audioUrl) {
      toast.success(`Audio bylo vytvořeno a stahuje se`)
      setAudioUrl(tmpAudio.audioUrl)
    } else {
      toast.error('Zvuková stopa je nedostupná')
      throw new Error('Zvuková stopa je nedostupná')
    }
  }

  const onGetAudioError = (error: any) => {
    toast.error(error)
    console.error(`Audio úsek se nepodařilo vytvořit`, error)
  }

  const handleSsmlChange = (value: string) => {
    setSsmlText(value)
  }

  const onDownloadClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    const link = document.createElement('a')
    if (typeof audioUrl === 'string') {
      link.href = audioUrl
    }
    link.download = `audio.mp3`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  useEffect(() => {
    // Cleanup function
    return () => {
      if (audioUrl) {
        setAudioUrl('')
      }
    }
  }, [audioUrl])

  return (
    <div
      className={`bg-${theme === 'dark' ? 'light' : 'dark'}-subtle text-${
        theme === 'dark' ? 'light' : 'dark'
      }`}
    >
      <h1>Ssml Playground</h1>
      <Form onSubmit={getAudio}>
        <Form.Group controlId="ssmlText">
          <Form.Label>SSML Text</Form.Label>
          <XmlEditor value={ssmlText} onChange={handleSsmlChange} />
        </Form.Group>
        <Button variant="primary" type="submit">
          Generovat audio
        </Button>
      </Form>

      {!!audioUrl && !audioLoading && (
        <>
          <CustomAudioPlayer audioSrc={audioUrl}></CustomAudioPlayer>
          <Button
            disabled={!audioUrl}
            onClick={onDownloadClick}
            variant="primary"
            type="submit"
            className="fw-bold my-2"
          >
            Stáhnout
          </Button>
        </>
      )}
      {audioLoading && (
        <Button variant="primary" disabled>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
          <span className="sr-only ms-2"> Načítání audia...</span>
        </Button>
      )}
    </div>
  )
}

export default AudioPage
